
if (!customElements.get('td-cart-upsell-atc')) {
  class TdCartUpsellAtc extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.querySelector('button').addEventListener('click', this.addToCart.bind(this));
    }
    addToCart(event) {
      event.preventDefault();
      this.dataset.isLoading = 'true';
      const data = {
        items: [{ id: parseInt(this.dataset.variantId), quantity: 1, properties: { "_upsell-item": true } }]
      };
      publish(PUB_SUB_EVENTS.cartUpdating, {
        source: 'cart-recommendations',
      })
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(response => {
          this.dataset.isLoading = 'false';
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.dataset.variantId,
            cartData: response,
          })
        })    
      })
      .catch(error => {
        this.dataset.isLoading = 'false';
      });
    }
  }
  customElements.define('td-cart-upsell-atc', TdCartUpsellAtc);
}